export default function(){
  let ContactModal;
  const openTelModal = (event) => {
    if (!ContactModal) ContactModal = document.getElementById('ContactModal')
    ContactModal.classList.add('is-active')
  }
  const closeTelModal = (event) => {
    if (!ContactModal) ContactModal = document.getElementById('ContactModal')
    ContactModal.classList.remove('is-active')
  }
  const openTelElsModal = document.getElementsByClassName('openTelModal');
  for (const openTelElModal of openTelElsModal) {
    openTelElModal.addEventListener('click', openTelModal)
  }
  const closeTelElsModal = document.getElementsByClassName('closeTelModal');
  for (const closeTelElModal of closeTelElsModal) {
    closeTelElModal.addEventListener('click', closeTelModal)
  }
}
